import axios from 'axios';
const login_link = process.env.API_LOCATION +'/authorize?redirect_to='+ encodeURIComponent(process.env.APP_LOCATION + "?login=true");

function isLoggedIn() {
    const now = new Date();
    
    var expireDate = localStorage.getItem("expiration_date");

    if (!expireDate) {
        return false;
    }
    expireDate = new Date(expireDate);

    return (now < expireDate);
}

function login() {
	var now = new Date();
	// Set expiration date one day from now
    now.setTime(now.getTime() + 24 * 60 * 60 * 1000);
    localStorage.setItem("expiration_date", now);
}


async function getUser() {
	var user = localStorage.getItem('user');
	if(user){
		return JSON.parse(user);
	}
	else{
		const path = process.env.API_LOCATION + `/user`;
		return new Promise((resolve, reject) => {
			axios.get(path)
		  		.then((res) => {
		  			resolve(res);
		  		})
		  		.catch((error) => {
		    		console.error(error);
		    		reject(error);
		  		});
		})
	}
}

export {isLoggedIn, getUser, login, login_link};



// WEBPACK FOOTER //
// ./src/utils/auth.js